<template>
    <div class="modal-window mbs010">
        <header class="modal-header">
            <div class="tit" v-if="$i18nUtil.getLanguage() === 'ko'">{{ $i18nUtil.trans("title.TermsAndPolicy.001", "이용약관/개인정보 취급방침") }}</div>
            <div class="tit" v-if="$i18nUtil.getLanguage() !== 'ko'">{{ $i18nUtil.trans("title.TermsAndPolicy.002", "이용약관") }}</div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content">
            <div class="tab_ty2" id="tabsTy1">
                <ul class="tab-menu">
                    <li v-for="(tab, index) in tabsTy1" v-bind:class="{active:currentTab1===index}">
                    <button type="button" v-on:click="currentTab1 = index">{{tab}}</button>
                    </li>
                </ul>
                <div class="tab-content">
                    <UseTerms v-show="currentTab1 == 0"/>
                    <PrivacyPolicy v-show="currentTab1 == 1"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UseTerms from "@/components/cowork/join/modal/UseTerms";
import PrivacyPolicy from "@/components/cowork/join/modal/PrivacyPolicy";
export default {
    components: {
        UseTerms,
        PrivacyPolicy
    },
    data() {
        return { 
            currentTab1: 0,
            tabsTy1: [],

        };
    },
    mounted() {
        if(this.$i18nUtil.getLanguage() === 'ko') {
            let tab = [ this.$i18nUtil.trans("title.UseTerms.001", "이용약관") , this.$i18nUtil.trans("title.PrivacyPolicy.001", "개인정보 취급방침") ];
            this.tabsTy1 = tab
        }else{
            let tab = [ this.$i18nUtil.trans("title.UseTerms.001", "이용약관") ];
            this.tabsTy1 = tab
        }
    },
    methods: {  },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/join/modal/TermsAndPolicy.vue